import ReactGA from 'react-ga4';

// Initialize GA with your tracking ID
export const initGA = (): void => {
  ReactGA.initialize('G-TNW69CB1X4');
  console.log('Google Analytics initialized with GA4');
};

// Track page views
export const trackPageView = (path: string): void => {
  ReactGA.send({ hitType: 'pageview', page: path });
  console.log(`Page view tracked: ${path}`);
};

// Track events
export const trackEvent = (category: string, action: string, label?: string, value?: number): void => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
  console.log(`Event tracked: ${category} - ${action}${label ? ` - ${label}` : ''}${value ? ` - ${value}` : ''}`);
};

// Booking-specific event tracking
export const trackBookingEvent = (action: string, bookingData?: any): void => {
  ReactGA.event({
    category: 'Booking',
    action,
    label: bookingData?.bookingId || bookingData?.bookingNumber,
    value: bookingData?.estimatedDuration?.car,
  });
  console.log(`Booking event tracked: ${action}`);
};

// Track form interactions
export const trackFormInteraction = (formName: string, action: string, fieldName?: string): void => {
  ReactGA.event({
    category: 'Form',
    action,
    label: `${formName}${fieldName ? ` - ${fieldName}` : ''}`,
  });
  console.log(`Form interaction tracked: ${formName} - ${action}${fieldName ? ` - ${fieldName}` : ''}`);
};

// Track user interactions, e.g., bookings, logins, sign-ups
export const trackUserInteraction = (action: string, data?: Record<string, any>): void => {
  ReactGA.event({
    category: 'User Interaction',
    action,
    ...data
  });
  console.log(`[GA UserInteraction] User interaction tracked: ${action}`, data);
};

// Track authentication events
export const trackAuthEvent = (action: string, method: string = 'email', userId?: string): void => {
  ReactGA.event({
    category: 'Authentication',
    action,
    label: method,
    value: undefined,
  });
  
  // If it's a login, set the user ID for user-level tracking
  if (action === 'Login Success' && userId) {
    ReactGA.set({ userId });
  }
  
  console.log(`Auth event tracked: ${action} - ${method}`);
};

// Track errors
export const trackError = (description: string, fatal: boolean = false): void => {
  ReactGA.event({
    category: 'Error',
    action: 'Error Occurred',
    label: description,
    nonInteraction: true,
  });
  console.log(`Error tracked: ${description}`);
};
